import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface UserState {
  userData: any;
  firebaseUser: any;
}

const initialState: UserState = {
  userData: null,
  firebaseUser: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<any>) => {
      state.userData = action.payload;
    },
    setFirebaseUser: (state, action: PayloadAction<any>) => {
      state.firebaseUser = action.payload;
    },
  },
});

export const { setUser, setFirebaseUser } = userSlice.actions;

export default userSlice.reducer;
